import { createAPI } from '../../common'

export default {
  // 获取短信验证码
  getVerifyCode: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0nfncfs0tqd0w20tfoeQipofWfsjgzDpef', 'get', config),
  // 校验短信验证码
  getCheckVerifyCode: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0nfncfs0tqd0w20qbttxpse0difdlDpef', 'get', config),
  // 校验短信验证码Enc
  getCheckVerifyCodeEnc: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0nfncfs0tqd0w20qbttxpse0difdlDpefFod', 'get', config),
  // 注册
  postRegister: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0nfncfs0tqd0w20cbdlfoe0sfhjtufsNfncfs',
      'post',
      config
    ),
  // 手机号密码登录
  postLogin: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0nfncfs0tqd0w20cbdlfoe0mphjo', 'post', config),
  // 手机短信登录
  postSmsLogin: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0nfncfs0tqd0w20cbdlfoe0wfsjgzDpefMphjo',
      'post',
      config
    ),
  // 重置过期时间
  resetPassModifyTime: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0nfncfs0tqd0w20cbdlfoe0sftfuQbttNpejgzUjnf',
      'post',
      config
    ),
  // 修改密码
  updatePassword: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0nfncfs0tqd0w20cbdlfoe0vqebufQbttxpse',
      'post',
      config
    ),
  // 找回密码
  postForgetPassword: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0nfncfs0tqd0w20cbdlfoe0gpshfuQbttxpse',
      'post',
      config
    ),
  // 登出
  postLogout: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0nfncfs0tqd0w20cbdlfoe0mphpvu', 'post', config, {
      isHideErrorMessage: true
    }),
  // 获取SM2公钥
  getPublicKey: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0nfncfs0tqd0w20cbdlfoe0hfuQvcmjdLfz', 'get', config),
  // 设置本地公私钥(PUGC)
  setLocalPubKeyByPUGC: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0nfncfs0tqd0w20cbdlfoe0vtfsQvcLfz', 'post', config, {
      neverLoading: true,
      isHideErrorMessage: true
    }
  ),
  // 刷新accessToken
  postRefreshAccessToken: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0nfncfs0tqd0w20cbdlfoe0sfgsftiBddfttUplfo',
      'post',
      config
    ),
  // 投稿平台获取登录配置
  getLoginConfig: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0nfncfs0tqd0w20cbdlfoe0hfuMphjoDpogjh', 'get', config),
  // 获取图形验证码
  getValidateImage: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0nfncfs0tqd0w20wbmjebufJnbhf', 'get', config),
  // 发送短信验证码-同时校验图形码
  postSendPhoneVerifyCodeNew: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0nfncfs0tqd0w20tfoeQipofWfsjgzDpefOfx',
      'post',
      config
    ),
  // 发送短信验证码-同时校验图形码Enc
  postSendPhoneVerifyCodeNewEnc: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0nfncfs0tqd0w20tfoeQipofWfsjgzDpefOfxFod',
      'post',
      config
    ),

  // 通过会员ID查询投稿平台账号信息
  getSubmissionPlatformAccountByUserId: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0nfncfs0tqd0w20cbdlfoe0hfuTvcnjttjpoQmbugpsnBddpvouCzVtfsJe',
      'get',
      config
    ),
  // 保存投稿平台账号信息
  postSaveSubmissionPlatformAccount: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0nfncfs0tqd0w20cbdlfoe0tbwfTvcnjttjpoQmbugpsnBddpvou',
      'post',
      config
    ),
  // 投稿平台预登录
  postPreLogin: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0nfncfs0tqd0w20cbdlfoe0qsfMphjo', 'post', config),

  // PUGC投稿平台
  // [接口地址](https://kb.fzyun.net/projects/qxrmt/wiki/%E9%80%9A%E8%AE%AF%E5%91%98%E5%BE%AE%E6%9C%8D%E5%8A%A1)
  // 获取平台配置
  getTenantConfig: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0cbunbo0dpogjh0hfuDpogjh', 'get', config),

  // 根据投稿位置选择的folderID
  getFolder: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0cbunbo0f60benjo0epn0gpmefs', 'get', config),
  // 获取子文件夹信息
  getSubFolder: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0cbunbo0f60benjo0epn0gpmefst', 'get', config),

  // 通讯员写稿
  // 写稿初始化
  getArticleInit: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0cbunbo0bsujdmf0joju', 'get', config),
  // 稿件保存
  postArticleSave: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0cbunbo0bsujdmf0tbwf', 'post', config),
  // 稿件提交
  postArticleSubmit: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0cbunbo0bdujpot0tvcnju', 'post', config),
  // 获取稿件详情
  getArticleDetail: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0cbunbo0bsujdmf0efubjm', 'get', config),
  // 获取详情页驳回记录
  getArticleDetailLogs: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0cbunbo0f60mpht', 'get', config),
  // 上传图片
  postUploadImage: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0cbunbo0bsujdmf0vqmpbeJnbhf', 'post', config),
  // 获取图片
  getImageUrl: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0cbunbo0bsujdmf0hfuJnbhfVsm', 'get', config),

  // 上传视频
  // 获取上传的token
  postFileToken: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0bqq0gjmf0uplfo', 'post', config),
  // 注册视频
  // postVideoRegister: (config) => createAPI('customEncryptApiName-1/0qsfcbunbo0bqq0wjefp0sfhjtufs', 'post', config),
  postVideoRegister: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0bqq0cbunbo0wjefp0sfhjtufs', 'post', config),
  // 查询转码进度
  // postVideoPercent: (config) => createAPI('customEncryptApiName-1/0qsfcbunbo0bqq0wjefp0usbot0qfsdfou', 'post', config),
  postVideoPercent: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0bqq0cbunbo0wjefp0usbot0qfsdfou', 'post', config),
  // 查询视频信息
  // postVideoInfo: (config) => createAPI('customEncryptApiName-1/0qsfcbunbo0bqq0wjefp0jogp', 'get', config),
  postVideoInfo: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0bqq0cbunbo0wjefp0jogp', 'get', config),

  // 删除稿件
  deleteArticleDelete: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0cbunbo0bdujpot0efmfuf', 'delete', config),
  // 追回稿件
  postArticleRecover: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0cbunbo0bdujpot0sfdpwfs', 'post', config),

  // getSecurityToken
  getSecurityToken: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0cbunbo0tfdvsjuz0uplfo', 'get', config),
  // 获取查看修改痕迹的所有副本
  getAssociationDetail: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0cbunbo0bdujpot0bttpdjbujpo0efubjm', 'get', config),

  // 接口定义
  // 稿件详情
  getArticlesDetails: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0cbunbo0bdujpot0bttpdjbujpoBsujdmf', 'get', config),
  // 修改痕迹 - 所有
  getAllArticlesTraces: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0cbunbo0wfstjpo0usbdf0bmm', 'get', config),
  // 获取不同用户修改痕迹
  getArticlesTracesByDifUserNew: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0cbunbo0wfstjpo0usbdf0vtfst0bmufsobuf0ofx',
      'get',
      config,
      vconfig
    ),
  // 获取不同用户修改痕迹
  getArticlesTracesByDifUser: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0cbunbo0wfstjpo0usbdf0vtfst0bmufsobuf',
      'get',
      config,
      vconfig
    ),
  // 根据指定用户获取修改痕迹 - 未使用
  getArticlesTracesBySameUser: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0cbunbo0wfstjpo0usbdf0vtfst0tbnf', 'get', config),
  // 根据选择版本获取修改痕迹
  getArticlesTracesByVersion: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0cbunbo0wfstjpo0usbdf0wfstjpot0tfmfdu',
      'get',
      config,
      vconfig
    ),

  // 获取公告类型
  getNoticeType: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0cbunbo0opujdf0hfuOpujdfUzqf', 'get', config),
  // 获取公告列表
  getNoticeList: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0cbunbo0opujdf0mjtu', 'post', config),
  // 获取公告详情
  getNoticeDetail: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0cbunbo0opujdf0efubjm', 'post', config),
  // 全部已读
  readNoticesAll: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0cbunbo0opujdf0sfbeBmm', 'post', config),
  // 获取文件外链
  getFilesLink: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0cbunbo0bsujdmf0gjmft0mjol', 'get', config),
  // 获取PUGC投稿平台授权信息
  getTenantAuth: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0cbunbo0xfnfejb0hfuNpet', 'get', config),
  // 获取自媒体栏目数据
  getMediaColumn: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0cbunbo0xfnfejb0hfuBqqTvcDpmt', 'get', config),

  // 自媒体-撤稿
  postArticleRevoke: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0cbunbo0xfnfejb0sfwplf', 'post', config),
  // 自媒体-删除
  postArticleDelete: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0cbunbo0xfnfejb0efmfuf', 'post', config),
  // 自媒体-发布
  postArticlePublish: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0cbunbo0xfnfejb0qvcmjti', 'post', config),
  // 自媒体-排序
  postArticleSorting: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0cbunbo0xfnfejb0tpsujoh', 'post', config),
  // 自媒体-详情
  postArticleDetail: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0cbunbo0xfnfejb0efubjm', 'post', config),
  // 自媒体-写稿初始化
  postArticleInit: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0cbunbo0xfnfejb0joju', 'post', config),
  // 自媒体-文章稿写稿
  postArticleWemediaSave: (config) =>
    createAPI('customEncryptApiName-1/0qsfcbunbo0cbunbo0xfnfejb0tbwf', 'post', config),
}
